import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { Dietitian } from '../../../../../../data/dietitian/domain/dietitian';
import {
  CustomTrackersProfilFacade,
  CustomTrackersProfilViewModel,
} from './custom-trackers-profil.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-custom-trackers-profil',
  templateUrl: './custom-trackers-profil.component.html',
  styleUrls: ['./custom-trackers-profil.component.scss'],
  providers: [CustomTrackersProfilFacade],
})
export class CustomTrackersProfilComponent {
  dietitian: Dietitian | undefined;
  maxTrackers = 10;
  dietitianStatus$: Observable<CustomTrackersProfilViewModel>;

  constructor(private facade: CustomTrackersProfilFacade) {
    this.dietitianStatus$ = this.facade.dietitianStatus$;
    this.dietitianStatus$.subscribe((model) => {
      this.dietitian = model.dietitian;
    });
  }
}
